import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledTitleTop } from './styles/StyledTitleTop';


class TitleTop extends Component {
  render() {
    const { title, number } = this.props;
    return (
      <StyledTitleTop>
        { number !== undefined &&
          <span className="title-top-num">{ number + '.' }</span>
        }        
        <span className="title-top-title"> { title } </span>
      </StyledTitleTop>
    );
  }
}


TitleTop.defaultProps = {
  number: undefined,
};



TitleTop.propTypes = {
  title: PropTypes.string.isRequired,
  number: PropTypes.number,
};


export default TitleTop;



// WEBPACK FOOTER //
// ./src/common/TitleTop/TitleTop.js